import { listEvents, splitEvents } from "@/api/events";
import { useResource } from "@/hooks/useResource";
import { Button } from "@/components/ui/Button";
import { Async } from "@/components/ui/Async";
import { Container, EmptyState, SectionHeading, SkeletonCards } from "@/components/ui/Primitives";
import { Reveal } from "@/components/motion/Reveal";
import { EventCard } from "@/components/cards/Cards";

/** Upcoming programmes. Past events are labelled as past — never presented as upcoming. */
export function Events() {
  const events = useResource("events", (signal) => listEvents(signal));
  return (
    <section className="events-section" aria-labelledby="events-title">
      <Container>
        <SectionHeading
          eyebrow="Gather"
          index="04"
          id="events-title"
          title={
            <>
              Programmes &amp; <em>gatherings</em>
            </>
          }
          action={
            <Button to="/events" variant="ghost" iconRight="arrowRight">
              All events
            </Button>
          }
        />
        <Async resource={events} skeleton={<SkeletonCards count={3} />} isEmpty={(d) => d.events.length === 0} empty={{ icon: "calendar", title: "No programmes announced yet", text: "New gatherings will be announced here." }}>
          {({ events: list }) => {
            const { upcoming, past } = splitEvents(list);
            return (
              <>
                {upcoming.length ? (
                  <div className="event-grid">
                    {upcoming.slice(0, 3).map((e, i) => (
                      <Reveal key={e.id} delay={i * 90}>
                        <EventCard event={e} variant={i === 0 ? "feature" : "default"} />
                      </Reveal>
                    ))}
                  </div>
                ) : (
                  <EmptyState
                    icon="calendar"
                    title="The next programme will be announced soon"
                    text="Meanwhile, we gather every Sunday for Celebration Service and every Wednesday for School of the Word."
                    action={
                      <Button to="/calendar" variant="ghost" size="sm" icon="calendar">
                        Church calendar
                      </Button>
                    }
                  />
                )}
                {!upcoming.length && past.length ? (
                  <div className="events-section__past">
                    <p className="events-section__past-title">Recent gatherings</p>
                    <div className="event-grid event-grid--past">
                      {past.slice(0, 2).map((e, i) => (
                        <Reveal key={e.id} delay={i * 90}>
                          <EventCard event={e} past />
                        </Reveal>
                      ))}
                    </div>
                  </div>
                ) : null}
              </>
            );
          }}
        </Async>
      </Container>
    </section>
  );
}
